import axios from 'axios';
import { smallNotification } from '@shared/services/gf.notification.service';
import { i18n } from '@/i18n';

export default {
  followUser(username, params) {
    return axios
      .post(`/api/user/settings/${username}/follow`, params)
      .then((res) => {
        smallNotification('success', { title: i18n.t('message.followOn', { title: username }) });
        return res?.data;
      })
      .catch((err) => {
        smallNotification('danger', { title: i18n.t('message.error_occured') });
        throw err;
      });
  },
  unfollowUser(username, params) {
    return axios
      .post(`/api/user/settings/${username}/unfollow`, params)
      .then((res) => {
        smallNotification('success', {
          title: i18n.t('message.unFollowOn', { title: username })
        });
        return res?.data;
      })
      .catch((err) => {
        smallNotification('danger', { title: i18n.t('message.error_occured') });
        throw err;
      });
  }
};
